import React, {FC} from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {Dropdown} from '../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownList} from '../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {DropdownItemIcon} from '../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemIcon';
import {SubmenuDropdownItem} from '../../../libs/shared/ui/src/components/dropdowns/items/submenuDropdownItem';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {NewConversationDropdownItems} from './newConversationDropdownItems';

/*
 * Props.
 */

interface CreateLinkedDiscussionDropdownMenuItemProps {
  onCreateLinkedConversation(): void;
  onCreateLinkedDiscussion(): void;
}

/*
 * Component.
 */

export const CreateLinkedDiscussionDropdownMenuItem: FC<CreateLinkedDiscussionDropdownMenuItemProps> = (
  props,
) => (
  <SubmenuDropdownItem
    icon={<DropdownItemIcon label={null} iconSize={16} iconName="linkedConversationsSmall" />}
    renderSubmenu={(dropdownProps) => (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <Dropdown {...dropdownProps} isExclusive={false} isInline={false}>
        <DropdownList>
          <NewConversationDropdownItems
            variant={VisualSizesEnum.SMALL}
            onComposeMessage={props.onCreateLinkedConversation}
            onComposeDiscussion={props.onCreateLinkedDiscussion}
          />
        </DropdownList>
      </Dropdown>
    )}
  >
    <Trans id="create-linked-conversation-dropdown-menu-item-create-linked-conversation">
      Create linked conversation
    </Trans>
  </SubmenuDropdownItem>
);
